/**
 * Comment Service
 * API calls for OKR and Key Result comments
 */

import { api } from './api';
import type { Comment, CreateCommentRequest } from '../types/comment';

class CommentService {
  /**
   * Get all comments for an OKR
   */
  async getComments(okrId: string): Promise<Comment[]> {
    const response = await api.get(`/okrs/${okrId}/comments`);
    return response.data.data.comments;
  }

  /**
   * Get all comments for a Key Result
   */
  async getKeyResultComments(keyResultId: string): Promise<Comment[]> {
    const response = await api.get(`/okrs/key-results/${keyResultId}/comments`);
    return response.data.data.comments;
  }

  /**
   * Create a new comment on an OKR or Key Result
   */
  async createComment(data: CreateCommentRequest): Promise<Comment> {
    const response = await api.post('/comments', data);
    return response.data;
  }
}

export const commentService = new CommentService();
